module.exports = __webpack_public_path__ + "img/ticket-001.73e678c1.svg";